import React, { useEffect, useState } from 'react'
import { FormFooterButton, InputCss } from '../../helper/CommonFunction';
import { ApiHandler } from '../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../components/ModalComponets';
import Loading from "../../components/Loading";

const AddDomainUsers = ({ isOpen, onClose, showData }) => {
    const { userToken } = useSelector((state) => state.user)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const initialState = {
        user_id: "",
        user_email: "",
        user_name: "",
        domain_name: "",
        app_name: "",
    };

    const [formData, setFormData] = useState(initialState);

    const { user_id, user_name, domain_name, user_email, app_name } = formData;

    useEffect(() => {
        if (isOpen) {
            setFormData(showData ? {
                user_id: showData.id || "",
                user_name: showData.full_name || "",
                domain_name: showData.domain || "",
                user_email: showData.email || "",
                app_name: showData.app_name || "",
            } : initialState);
        }
    }, [isOpen, showData]);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!domain_name || !user_name || !user_email || !app_name) {
            setError("All fields are required");
            return;
        }

        const body = {
            user_id: user_id,
            user_name: user_name,
            user_email: user_email,
            domain_name: domain_name,
            app_name: app_name,
        }
        setError(null);

        try {
            setLoading(true);
            const response = await ApiHandler("/add_domain.php", "POST", body, userToken, dispatch, navigate);

            if (response.data.status === "1") {
                toast.success(response.data.msg || "Domain successfully added!");
                setFormData(initialState);
                navigate("/admin/users/domains");
            } else {
                toast.error(response.data.msg);
            }
        } catch (error) {
            console.error("Error submitting domain", error);
        } finally {
            setLoading(false);
            handleClose();
        }
    };

    if (loading) return <Loading />;
    return (
        <ModalLarge isOpen={isOpen} title={`Add Domain`} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1 gap-x-3 gap-y-4'>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-gray-800 font-semibold mb-1"
                        >
                            App Url <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="text"
                            name="domain_name"
                            value={domain_name}
                            placeholder='Enter App Url'
                            onChange={handleInputChange}
                            required
                            className="w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-300 text-gray-700 text-sm transition-all duration-200"
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="method"
                            className="block text-gray-800 font-semibold mb-1"
                        >
                            User Email <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="text"
                            value={user_email}
                            className="w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 text-gray-500 text-sm mt-1 bg-orange-50/50 cursor-not-allowed"
                            disabled
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-gray-800 font-semibold mb-1"
                        >
                            User Name <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="text"
                            value={user_name}
                            className="w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 text-gray-500 text-sm mt-1 bg-orange-50/50 cursor-not-allowed"
                            disabled
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="method"
                            className="block text-gray-800 font-semibold mb-1"
                        >
                            App Name <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="text"
                            name="app_name"
                            value={app_name}
                            onChange={handleInputChange}
                            className="w-full px-3 py-2.5 border border-orange-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-300 text-gray-700 text-sm transition-all duration-200"
                            placeholder="Enter or edit App Name"
                            required
                        />
                    </div>
                </div>

                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default AddDomainUsers;